import React from "react";
import { ApplicationsTable } from "./ApplicationsTable";

export const HomePage: React.FC = () => {
  return (
    <div className="h-full overflow-auto bg-gray-50">
      <div className="container mx-auto px-6 py-10">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            Applications
          </h1>
          <p className="text-gray-500 text-sm">Manage and preview your applications</p>
        </div>
        <ApplicationsTable />
      </div>
    </div>
  );
};
